<template>

  <Modal :visible="visible" @close="$emit('close')" title="Nalaganje datotek">
    <div class="row" v-show="type !== 'Standalone'">
      <div class="col">
        <p>Datoteka se poveže z nalogom takoj (pred klikom na "shrani")!</p>
      </div>
    </div>

    <div class="alert alert-warning" role="alert" v-show="message">
      {{ message }}
    </div>

    <div class="row">
      <div class="col">
        <input ref="fileEl" v-on:change="validateFiles" type="file" multiple /> <!-- v-on:change="handleFileUpload()" accept="image/*;capture=camera" -->
      </div>
    </div>

    <div class="row">
      <div class="col">
        {{ fileEl?.files.length }} <span class="badge bg-secondary" v-show="type !== 'Standalone'">{{ type }}</span>
      </div>
    </div>

    <template v-slot:buttons>
      <button class="btn btn-success me-3" type="button" @click="uploadFiles" :disabled="!hasFiles">Naloži</button>
    </template>
  </Modal>
</template>

<script setup>
import { ref, toRef, toRefs, computed, defineComponent, watch, reactive, onMounted, inject } from "vue"

import { useAuth } from "../composition-api/useAuth"
import { setError, startLoading, stopLoading } from "./Notification"

defineOptions({ name: "Upload" })

const props = defineProps({
    allowedType: { type: String, default: "" },
    visible: { type: Boolean, default: false },
    type: { type: String, required: true },
    attachmentType: { type: String, default: "Upload" },
    id: { type: String },
  })

const emit = defineEmits(["add", "close"])


const { fetchAuthAsync } = useAuth()
const fileEl = ref(null)
const hasFiles = ref(false)
const id = toRef(props, "id")
const type = toRef(props, "type")
const attachmentType = toRef(props, "attachmentType")
const message = ref("")

const validateFiles = () => {
  message.value = ""
  for (let i = 0; i < fileEl.value.files.length; i++) {
    if (!fileEl.value.files.item(i).type.startsWith(props.allowedType)) {
      message.value = "Napaka pri nalaganju datoteke. Datoteka ni tipa " + props.allowedType
      return
    }
  }
  hasFiles.value = true
}

// duplicate to AttachFromCamera
const uploadFileAsync = async (f) => {
  if (type.value === "Standalone") {
    console.warn("Standalone operation.")
    hasFiles.value = false
    emit("add", f)
    return
  }

  startLoading("uploadFileAsync")
  try {
    const form = new FormData()
    form.append("file", f)
    const attachmentTypeQuery = attachmentType.value ? `?attachmentType=${attachmentType.value}` : ""
    const raw = await fetchAuthAsync(
      `${AZURE_URI}/Attachments/${type.value}/${id.value}${attachmentTypeQuery}`,
      "POST",
      form,
    )

    if (raw.status !== "ok" || !raw.attachment) {
      setError(raw)
    } else {
      hasFiles.value = false
      emit("add", raw.attachment)
    }
  } catch (e) {
    setError(e)
  }
  stopLoading("uploadFileAsync")
}

const uploadFiles = async () => {
  for (let i = 0; i < fileEl.value.files.length; i++) {
    const f = fileEl.value.files.item(i)
    uploadFileAsync(f)
  }
}
</script>
